import tokenApiService from '@/request/token/token.api.service';
import { IHotToken } from '@/request/token/token.response.interface';
import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

export const useSearchToken = () => {
  const [keyword, setKeyword] = useState('');
  const [searchTokenList, setSearchTokenList] = useState<IHotToken[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchSearchTokenList = async (keyword: string) => {
    try {
      setIsLoading(true);
      const res = await tokenApiService.getSearchToken({ query: keyword });
      if (res.code == 0) {
        setSearchTokenList(res.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const debouncedFilter = useMemo(
    () =>
      debounce((value: string) => {
        fetchSearchTokenList(value);
      }, 500),
    [],
  );

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setKeyword(value);
    if (value.length == 0) return setSearchTokenList([]);
    debouncedFilter(value);
  };

  useEffect(() => {
    return () => {
      debouncedFilter.cancel();
    };
  }, [debouncedFilter]);

  return { keyword, isLoading, searchTokenList, onChange, setKeyword };
};
